export const REQUEST_ENDPOINT_ZAPPIER_IBEX =
  "https://hooks.zapier.com/hooks/catch/10364333/blco2w9/"
